import * as React from 'react';
import styled from 'styled-components';
import { Card, CardTitle, CardContent } from '../../../Components';
import { ProfessorModel } from '../../../Store/Professor';

interface IProps {
  professor: ProfessorModel;
}

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 1rem;
  position: relative;
  margin-left: auto;
  margin-right: auto;
`;

export const InfoProfessorCard: React.FC<IProps> = ({ professor }: IProps) =>
  <Card>
    <CardTitle>Informações do Orientador</CardTitle>
    <CardContent>
      <Container>
        <span><b>Nome:</b> {professor.nome}</span>
        <span><b>Email:</b> {professor.email}</span>
      </Container>
    </CardContent>
  </Card>;